import { useState, useGlobal, setGlobal } from "reactn";
import { getJWTInfo, getMobileData } from "../services/Api";

const MyDeliveriesHooks = ({ userProfile }) => {
	const [showMobileBanner, setShowMobileBanner] = useGlobal("mobileBanner");
	const [showCustomsBanner, setShowCustomsBanner] = useGlobal("customsBanner");
	const [values] = useGlobal("values");

	const callMobileDataApi = () => {
		const { uid } = userProfile;

		getJWTInfo().then(() => {
			getMobileData(uid)
				.then(response => {
					if (response && response.status === 200) {
						if (response.data) {
							// mobiles returned from my deliveries
							const { mobileNumbers } = response.data;
							// mobile numbers in CIAM
							const { phones } = JSON.parse(sessionStorage.getItem("userProfile"));
				
							if (typeof phones === "undefined") return;
				
							// check the my deliveries mobile against the primary profile mobile number
							const primaryMobile = mobileNumbers.filter(mobile => mobile.mobileNumber === getMobileNumber(phones));
							
							setGlobal({
								values: { ...values, "mobileNumbers": primaryMobile }
							});
						
							if(primaryMobile.filter(numbers => numbers.verified === false).length > 0 || !primaryMobile.length){
								setShowMobileBanner(true);
							}
						}
					}
				})
				.catch((error) => {
					console.log(error);
				})
		});
	};

	// compare a date in the past to a date supplied to this function
	const checkDateInThePast = (date, days) => {
		// get two days ago from today
		const daysInPast = new Date();
			const compareDate = new Date(date);

		// find the days in the passed based on the days param
		daysInPast.setDate(daysInPast.getDate() - days);

		// compare the selectedDate
		if (compareDate > daysInPast) {
			return true;
		}
		return false;
	};
	
	const filterReceivingItems = trackingItems => {
		const receivingItemsData = trackingItems.filter(item => {
			if (item.returnType === "RECEIVER") {
				item.customsPaymentRequired && setShowCustomsBanner(true);
				
				// APMD-44: if the item is In Transit, Customs, Received or Sorting: display it as inbound ()
				if (["0", "1", "2", "3"].indexOf(item.lastTrackingEventCategoryId) > -1) {
					return true;
				}
				// APMD-44:  4, 5 and 6 are to be displayed in the inbound items tab in some cases
				if (["4", "5", "6"].indexOf(item.lastTrackingEventCategoryId) > -1) {
					// while the <delivery date> is greater than 2 calendar days previous to 'today'
					if (checkDateInThePast(item.dateDelivered, 2)) {
						return true;
					}
				}
			}

			return false;
		});

		return receivingItemsData;
	};
	
	const filterSendingItems = trackingItems => {
		const sendingItems = trackingItems.filter(item => {
			return item.returnType === "SENDER";
		});

		return sendingItems;
	};

	const getMobileNumber = phones => {
        let mobileNumber = "";
        for (let i = 0; i < phones.length; i += 1) {
            if (phones[i].type.toUpperCase() === "MOBILE") {
                mobileNumber = phones[i].number;
            }
        }
        return mobileNumber;
    };

	return {
		showMobileBanner,
		showCustomsBanner,
		callMobileDataApi,
		filterReceivingItems,
		filterSendingItems
	}
}

export default MyDeliveriesHooks;
